import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function CenturyIllustration({
  achievementId,
  variant = 'pixel',
  // Century unlocks the pixel variant, so we default to it
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3674" data-mp="mydow9lta0ji">
      <div className="relative w-full h-full bg-gradient-to-br from-emerald-100 to-teal-200 overflow-hidden" data-id="element-3675" data-mp="rwozimjxkf2s">
        {/* Background: Sunburst */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3676" data-mp="10rd2u75y3moy">
          <g className="origin-center animate-[spin_20s_linear_infinite]" style={{
          transformOrigin: '100px 100px'
        }} data-id="element-3677" data-mp="1ap0zj2n4349r">
            {[...Array(12)].map((_, i) => <path key={i} d="M100 100 L90 -20 L110 -20 Z" fill="#34D399" fillOpacity="0.3" transform={`rotate(${i * 30} 100 100)`} data-id="element-3678" data-mp="uqgyfdbyx387" data-mpi={i} />)}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[10%]" data-id="element-3679" data-mp="1igufy9wxfjoj">
          <div className="w-[70%] h-[70%] flex items-center justify-center" data-id="element-3680" data-mp="1eezk3kxrlyi5">
            <DjaySpecimen look={{
            variant,
            accessory: 'badge100'
          }} size="hero" emotion={isUnlocked ? 'celebrating' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3681" data-mp="1eh3khswggfdo" />
          </div>
        </div>

        {/* Foreground: Banners and 100s */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3682" data-mp="2ga3ydilja6vx">
            <path d="M-10 30 Q100 60 210 30 L210 45 Q100 75 -10 45 Z" fill="#EF4444" data-id="element-3683" data-mp="27ibpvdg2l7tz" />
            <path d="M-10 35 Q100 65 210 35 L210 40 Q100 70 -10 40 Z" fill="#FCA5A5" data-id="element-3684" data-mp="2bhste1bxruwi" />

            <text x="30" y="45" fontFamily="sans-serif" fontSize="14" fontWeight="900" fill="white" transform="rotate(10 30 45)" data-id="element-3685" data-mp="1xlfft3aiwdnb">
              100
            </text>
            <text x="170" y="45" fontFamily="sans-serif" fontSize="14" fontWeight="900" fill="white" transform="rotate(-10 170 45)" data-id="element-3686" data-mp="1skrn8d6nboqz">
              100
            </text>

            <circle cx="40" cy="150" r="8" fill="#FBBF24" data-id="element-3687" data-mp="1bbysn7myfk3w" />
            <circle cx="160" cy="160" r="12" fill="#3B82F6" data-id="element-3688" data-mp="179lr6vf8q8cx" />
            <circle cx="180" cy="120" r="6" fill="#10B981" data-id="element-3689" data-mp="17b6min9dpvbu" />
            <circle cx="20" cy="110" r="10" fill="#EF4444" data-id="element-3690" data-mp="1l109f01bq5ix" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}